import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  MenuItem,
  Container,
  Grid,
  Typography,
  InputLabel,
  FormControl,
  Box,
  CircularProgress,
  TextField,
} from "@mui/material";
import Select from "@mui/material/Select";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

// ----------------------------------------------------------------------

export default function EditMatchPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [matchId, setMatchId] = useState(false);
  const [match, setMatch] = useState(null);
  const [competition, setCompetition] = useState(null);
  const [conferences, setConferences] = useState([]);
  const [teams, setTeams] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [gameStart, setGameStart] = useState();

  const handlePickemStartChange = (newValue) => {
    setGameStart(newValue);
  };

  useEffect(() => {
    if (searchParams.has("matchId")) {
      setLoading(true);

      let matchId = searchParams.get("matchId");
      setMatchId(Number(matchId));
      const competition = searchParams.get("type");
      setCompetition(competition);

      const fetchDataMatch = async () => {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/match/${matchId}`
        );
        const [ match ] = data;
        console.log('fetchDataMatch', match)
        setMatch(match);
        setCompetition(match.competition)
        return match;
      };

      const fetchDataConferences = async () => {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/conferences?competition=${competition}`
        );
        setConferences(data);
        return data;
      };

      const fetchDataTeams = async () => {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/teams?competition=${competition}`
        );
        setTeams(data);
        return data;
      };

      const fetchDataRounds = async () => {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/rounds?competition=${competition}`
        );
        setRounds(data);
        return data;
      };

      Promise.all([
        fetchDataMatch(),
        fetchDataTeams(),
        fetchDataConferences(),
        fetchDataRounds(),
      ])
        .then(([match, teams, conferences, rounds]) => {
          setMatch(match);
          setTeams(teams);
          setConferences(conferences);
          setRounds(rounds);
        })
        .finally(() => setLoading(false));
    }
  }, [searchParams]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (
      (name === "home_team_id" && !!value && match.away_team_id === value) ||
      (name === "away_team_id" && !!value && match.home_team_id === value)
    ) {
      setError({ name, message: "Error select team" });
    } else if (name === "home_team_id" || name === "away_team_id") {
      setError(false);
    }

    setMatch({ ...match, [name]: value });
  };

  const handleSubmit = () => {
    if (!!match) {
      setLoading(true);
      axios
        .put(`${process.env.REACT_APP_API_BASE_URL}/admin/match/${matchId}`, {
          ...match,
          startTimeUtc: gameStart,
        })
        .then(function (response) {
          navigate(`/dashboard/matches?type=${competition}`);
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <>
      <Helmet>
        <title> Match </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Edit Match
          </Typography>
        </Stack>

        <Card style={{ padding: 20 }}>
          {!match || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <TextField
                    label="Match Feed Id"
                    placeholder="Match Feed Id"
                    type="text"
                    name="matchFeedId"
                    value={match.matchFeedId}
                    onChange={(e) => handleChange(e)}
                  />
                </FormControl>

                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <InputLabel id="demo-simple-select-label-conferences">
                    Conferences
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label-conferences"
                    id="demo-simple-select-conferences"
                    value={match?.conferenceId}
                    label="Conferences"
                    name="conferenceId"
                    onChange={(e) => handleChange(e)}
                  >
                    {conferences.map((conference) => (
                      <MenuItem
                        value={conference.conferenceId}
                        key={conference.conferenceId}
                      >
                        {conference.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <InputLabel id="demo-simple-select-label-rounds">
                    Rounds
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label-rounds"
                    id="demo-simple-select-conferences"
                    value={match.roundId}
                    name="roundId"
                    label="Rounds"
                    onChange={(e) => handleChange(e)}
                  >
                    {rounds.map((round) => (
                      <MenuItem value={round.roundId} key={round.roundId}>
                        {round.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <InputLabel id="demo-simple-select-label-home_team">
                    Home Team
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label-home_team"
                    id="demo-simple-select-home_team"
                    value={match.homeTeamId}
                    name="homeTeamId"
                    label="Home Team"
                    onChange={(e) => handleChange(e)}
                    error={error.name === "homeTeamId"}
                  >
                    <MenuItem value={null}>Reset Team</MenuItem>
                    {teams.map((team) => (
                      <MenuItem
                        value={team.teamId}
                        key={`home_team${team.teamId}`}
                      >
                        {team.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <InputLabel id="demo-simple-select-label-away_team">
                    Away Team
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label-away_team"
                    id="demo-simple-select-away_team"
                    value={match.awayTeamId}
                    name="awayTeamId"
                    label="Away Team"
                    onChange={(e) => handleChange(e)}
                    error={error.name === "awayTeamId"}
                  >
                    <MenuItem value={null}>Reset Team</MenuItem>
                    {teams.map((team) => (
                      <MenuItem
                        value={team.teamId}
                        key={`away_team_${team.teamId}`}
                      >
                        {team.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <TextField
                    label="Slot"
                    placeholder="Slot"
                    type="text"
                    name="slot"
                    value={match.slot ?? ""}
                    onChange={(e) => handleChange(e)}
                    disabled={true}
                  />
                </FormControl>

                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                      label="Start UTC"
                      value={gameStart}
                      onChange={handlePickemStartChange}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12} rowSpacing={40}>
                <Box spacing={15}>
                  <Button
                    variant="contained"
                    disabled={!!error}
                    onClick={() => handleSubmit()}
                    sx={{ mr: 1 }}
                  >
                    Create
                  </Button>

                  <Button
                    variant="contained"
                    onClick={() =>
                      navigate(
                        `/dashboard/set-result-match?matchId=${matchId}&type=${competition}`
                      )
                    }
                  >
                    Set Result
                  </Button>
                </Box>
              </Grid>
            </Grid>
          )}
        </Card>
      </Container>
    </>
  );
}
